import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import * as moment from "moment";
import { WidgetService } from '../../../services/widget/widget.service';
import { WidgetHelperService } from '../widget-helper.service';


@Component({
  selector: 'trend-map',
  templateUrl: './trend-map.component.html',
  styleUrls: ['./trend-map.component.scss']
})
export class TrendMapComponent implements OnInit {
  @Input('graphData') graphData: any;
  @Input('requestBody') requestBody: any;
  @Input('groupData') groupDataActual: any;
  dateTimeF = "YYYY-MM-DD HH:mm:ss";
  options;
  columnChart;
  isTrendL = false;
  isTrendBar = false;
  trendName = {
    isCurrent: "Current Day",
    isPastD: "Past Day",
    isPastW: "Past Week",
    isPastM: "Past Month",
    isPastY: "Past Year"
  };

  momentType = {
    isCurrent: "day",
    isPastD: "day",
    isPastW: "week",
    isPastM: "month",
    isPastY: "year"
  };

  trendAr = [];
  boxColor = "#fff";
  textColor = "#000";
  kpiTitle;
  trendTitle = "";
  trendFrom = moment().format("YYYY-MM-DD");
  currentDateTrendC = 0;
  totalCountToBeProssed: number = 0;
  kpiNumericConfig;
  constructor(private commonService: CommonService, private widgetService: WidgetService, private widgetHelperService: WidgetHelperService) {

  }

  ngOnChanges() {
    this.prepareData();
    this.plotChart();
  }

  plotChart() {
    if (this.columnChart) {
      //Remove previous point
      for (var i = this.columnChart.series.length - 1; i >= 0; i--) {
        this.columnChart.series[i].remove();
      }

      if (this.totalCountToBeProssed == this.trendAr.length && this.isTrendBar) {
        //add new points
        this.widgetHelperService.seriesDataForTrend(this.trendAr, this.currentDateTrendC, this.trendName).forEach((obj, i) => {
          // this.columnChart.series[i].remove();
          this.columnChart.addSeries(obj)
          // this.columnChart.series[i].setData(obj.data);

        });
      }
    }
  }


  ngOnInit() {
    // this.prepareData();
  }

  // getCurrentDayTrend(){
  //   this.trendFrom = this.groupDataActual.showTrend ? this.groupDataActual.trendFrom : this.trendFrom || this.trendFrom;
  //   let currentDReq = Object.assign({}, this.requestBody);

  //   let a = moment(this.trendFrom, "YYYY-MM-DD HH:mm:ss").startOf('day').format(this.dateTimeF);
  //   a = this.commonService.getOffsetConverted(a, this.dateTimeF, false);

  //   let b = moment(this.trendFrom, "YYYY-MM-DD HH:mm:ss").endOf('day').format(this.dateTimeF);
  //   b = this.commonService.getOffsetConverted(b, this.dateTimeF, false);

  //   currentDReq.from = a;
  //   currentDReq.to = b;


  //   this.widgetService.kpiData(currentDReq).subscribe(
  //     currentV => {
  //       if (currentV && currentV.dataFilter[0].data.length > 0)
  //         this.currentDateTrendC = currentV.dataFilter[0].data[0].value;

  //         this.prepareData();
  //     },
  //     (err) => { }
  //   );
  // }


  prepareData() {
    this.trendAr = [];
    if (this.graphData.udf && this.graphData.udf.trendConfig) {
      let tempTrendConfig = Object.assign({}, this.graphData.udf.trendConfig);

      //Since Trend can have only 1 kpi filter
      this.kpiNumericConfig = typeof this.graphData.udf.kpiNumberConfig[0] === 'undefined' ? {} : this.graphData.udf.kpiNumberConfig[0];


      this.textColor = tempTrendConfig.valueColor;
      this.boxColor = tempTrendConfig.boxColor;
      this.isTrendBar = tempTrendConfig.isTrendBar;
      this.trendTitle = this.graphData.title;
      //get trend date
      this.trendFrom = this.groupDataActual.showTrend ? this.groupDataActual.trendFrom : this.trendFrom;
      // console.log("Trend From: ",this.trendFrom);

      this.trendFrom = this.commonService.getDateConverted(this.trendFrom, this.dateTimeF);
      this.trendFrom = moment(this.trendFrom).format("YYYY-MM-DD");

      if (this.graphData.dataFilter && this.graphData.dataFilter.length > 0) {
        this.kpiTitle = this.graphData.dataFilter[0].label || "";
      }

      //
      if (this.graphData && this.graphData.dataFilter[0].data.length > 0) {
        this.currentDateTrendC = this.graphData.dataFilter[0].data[0].value;
      }
      Object.keys(this.graphData.udf.trendConfig).forEach(key => {
        //check for boolean value
        if (key != "isTrendBar" && typeof tempTrendConfig[key] == typeof true && tempTrendConfig[key]) {
          let d = { id: key, value: { currentV: 0, previousV: 0, changeInP: 0, isTrendL: false } };
          this.trendAr.push(d);
        }
      });


      // console.log(this.trendAr);
      this.getTrendvalue();
    }
  }


  getTrendvalue() {
    if (this.requestBody) {

      this.trendAr.forEach(obj => {
        // let currentD = Object.assign({}, this.requestBody);
        let yesterR = Object.assign({}, this.requestBody);
        //since moment require this type of constructor only
        let dayT: moment.unitOfTime.StartOf;
        let subT: moment.unitOfTime.DurationConstructor;

        dayT = subT = this.momentType[obj.id];

        //get previous day month and year
        let yesF = moment(this.trendFrom).subtract(1, subT).format(this.dateTimeF);
        yesF = this.commonService.getDateConverted(yesF, this.dateTimeF);

        //since we are considering same day therefore we are adding 1 day to yesrtday data
        let yesT = moment(yesF).add(1, 'day').endOf('day').format("YYYY-MM-DD HH:mm:ss");
        yesT = this.commonService.getDateConverted(yesT, this.dateTimeF);


        yesterR.from = yesF;
        yesterR.to = yesT;

        this.getCountVal(yesterR, obj.id);
      });
    }
  }

  getCountVal(requP, reqkey) {
    this.widgetService.kpiData(requP).subscribe(
      res => {
        this.calCulateTrend(res, reqkey);
      },
      (err) => { }
    );
  }
  calCulateTrend(res, reqkey) {
    if (res) {

      let yestertV = res;
      let yC = 0;
      let incr = 0;
      let changeInP = 0;


      if (yestertV && yestertV.dataFilter[0].data.length > 0)
        yC = yestertV.dataFilter[0].data[0].value;

      //for current day we don't need calculation just show data as it is
      if (reqkey != "isCurrent") {
        incr = this.currentDateTrendC - yC;
        changeInP = yC == 0 ? 0 : incr / yC * 100;
        changeInP = parseFloat(changeInP.toFixed(2));
        changeInP = changeInP == NaN ? 0 : changeInP;
      }
      // console.log(changeInP);
      this.trendAr.map(ob => {
        if (ob.id == reqkey) {
          ob.value.changeInP = changeInP;
          ob.value.currentV = this.currentDateTrendC;
          ob.value.previousV = yC;
          ob.value.isTrendL = true;
        }
      });
      this.totalCountToBeProssed++;
    }
    if (this.totalCountToBeProssed == this.trendAr.length && this.isTrendBar) {
      //$(`#${this.graphData.udf.widgetId}`).css('height', '705px');
      this.plotGraph();
    }
  }

  plotGraph() {
    let dataLabels = {
      enabled: true,
      formatter: function () {
        let val = this.y;
        if (!val) {
          val = 0;
        }
        let cVal = "" + val;
        if (val >= 1000000000) { cVal = (val / 1000000000).toFixed(2) + 'B'; }
        else if (val >= 1000000) { cVal = (val / 1000000).toFixed(2) + 'M'; }
        else if (val >= 1000) { cVal = (val / 1000).toFixed(2) + 'K'; }
        else { cVal = (val).toFixed(0) }

        let v = cVal.split(".");
        if (v[1] == "00B" || v[1] == "00M" || v[1] == "00K") {
          cVal = v[0] + v[1].replace("00", "");
        }
        return cVal;
      },
    }
    this.options = {
      chart: {
        type: "column",
        zoomType: 'x'
      },
      credits: {
        enabled: false
      },
      xAxis: { categories: [this.trendTitle] },
      // yAxis: this.widgetHelperService.getYAxisConfig(this.componentData),
      title: {
        text: ''
      },
      subtitle: {
        text: document.ontouchstart === undefined ?
          'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
      },
      plotOptions: {
        series: {
          turboThreshold: 5000,
          boostThreshold: 100,
          dataLabels: dataLabels
        }
      },
      series: this.widgetHelperService.seriesDataForTrend(this.trendAr, this.currentDateTrendC, this.trendName)//this.widgetHelperService.getSeriesData(this.componentData)
    };
    this.totalCountToBeProssed = 0;
  }

  saveInstance(chartInstance) {
    this.columnChart = chartInstance;
  }

  formatNumber(val) {
    let no = "0";
    let numberFormat = this.kpiNumericConfig && this.kpiNumericConfig.kpiNumberFormat ? this.kpiNumericConfig.kpiNumberFormat : 0
    if (val) {
      if (numberFormat == "-1") {
        no = this.commonService.shortNumberFormat(val);
        if (this.graphData.dataFilter[0].isThousandSeperator)
          no = this.commonService.formatNumberString(no, true);
        else
          no = this.commonService.formatNumberString(no, false);
      } else {
        no = this.commonService.formatNumberString(val.toFixed(numberFormat), false);
      }
    }
    return no;
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/trend-map/trend-map.component.ts